import { Textarea, TextareaProps } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import InputTooltip from '../Input/InputTooltip';
import { Container, Error, Label, IconContainer, MaxCharsContainer } from './styles';

interface ICustomTextAreaProps extends TextareaProps {
  id?: string;
  name?: string;
  error?: string;
  label?: string | null;
  icon?: any;
  height?: number;
  tooltip?: string;
  isRequired?: boolean;
  helperText?: string;

  maxChars?: number;
  internalRef?: React.Ref<HTMLTextAreaElement>;
}

const CustomTextArea: React.FC<ICustomTextAreaProps> = ({
  error,
  label = null,
  icon = false,
  id,
  height,
  maxChars,
  value,
  internalRef,
  tooltip,
  isRequired,
  helperText,
  ...rest
}) => (
  <Container error={error} htmlFor={id} height={height}>
    {label && (
      <Label>
        <p>{label}</p>

        {isRequired && (
          <p>
            <span>*</span>
          </p>
        )}

        {tooltip && <InputTooltip label={tooltip} />}
      </Label>
    )}

    {icon ? (
      <IconContainer>
        <div>
          <FontAwesomeIcon icon={icon} />
        </div>

        <Textarea id={id} value={value} {...rest} />
      </IconContainer>
    ) : (
      <Textarea ref={internalRef} id={id} value={value} {...rest} />
    )}

    {maxChars && (
      <MaxCharsContainer reachedMaxChars={value ? value.toString().length >= maxChars : false}>
        {`${value ? value.toString().length : 0}/${maxChars}`}
      </MaxCharsContainer>
    )}

    {error && <Error>{error}</Error>}

    {helperText && <p className="helperText error">{helperText}</p>}
  </Container>
);

export default CustomTextArea;
